import { Component, Input, HostListener, Output, EventEmitter } from "@angular/core";
import { SortDirection, ISortEvent } from "@schema/data-grid";
import { IconList } from "@schema/ui/icons";
import { faSort, faSortDown } from "@fortawesome/free-solid-svg-icons";

const rotate: { [key: string]: SortDirection } = { asc: "desc", desc: "asc", "": "asc" };

@Component({
  selector: "app-data-grid-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class DataGridHeaderComponent {

  /**
   * The property name to sort on
   */
  @Input()
  public sortable: string;

  /**
   * The property name to display
   */
  @Input()
  public title: string;

  /**
   * The sort direction
   */
  @Input()
  public direction: SortDirection = "";

  /**
   * Sort event
   */
  @Output()
  public sort = new EventEmitter<ISortEvent>();

  public icons: IconList = {
    sortAvailable: faSort,
    sorted: faSortDown,
  };

  @HostListener("click") rotate(): void {
    console.log("rotate()");
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }

}
